module.exports = __webpack_public_path__ + "img/text_icon.e379a0d0.svg";